import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {OccEndpointsService} from "@spartacus/core";

@Injectable({
  providedIn: 'root'
})
export class GonvarriOrderPdfAdapter {

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  public getSingleOrderPdf(
    orderCode: string,
    pdfType: string,
    index: number,
  ): Observable<any> {

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/pdf')
      .set('Accept', 'application/pdf');

    return this.http
      .post(
        this.getSingleOrderPdfUrl(
          orderCode,
          pdfType,
          index
        ),
        null,
        {
          headers: headers,
          responseType: 'blob' as 'json',
        }
      )
  }

  public getMultipleOrdersPdfs(
    ordersCode: string[]
  ): Observable<any> {
    const headers = new HttpHeaders()
      .set('Accept', 'application/zip');

    return this.http
      .post(
        this.getMultipleOrdersPdfsUrl(),
        ordersCode,
        {
          headers: headers,
          responseType: 'blob' as 'json',
        }
      )
  }

  private getSingleOrderPdfUrl(
    orderCode: string,
    pdfType: string,
    index: number,
  ): string {
    const queryParams = { orderCode, pdfType, index };
    return this.occEndpointsService.buildUrl(`/my-account/pdf/download-sales-order`, {
      queryParams
    })
  }

  private getMultipleOrdersPdfsUrl(): string {
    const queryParams = {  };
    return this.occEndpointsService.buildUrl(`/my-account/orders/download-multiple-orders`, {
      queryParams
    })
  }

}
